import * as apiUtils from "@/utils/apiUtils"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {
    removeAuthToken: state => {
      localStorage.removeItem("token")
    },
    updateAuthToken: (state, token) => {
      localStorage.setItem("token", token)
    }
  },
  // -----------------------------------------------------------------
  actions: {
    login: (context, { email, password }) => {
      var path = "/auth/login"
      var data = {
        email: email,
        password: password
      }

      var result = apiUtils.post(path, data)
      return result
    },
    loginByGoogle: (context, { token }) => {
      var path = "/auth/login/google"
      var data = {
        token: token
      }

      return apiUtils.post(path, data)
    },
    logout: context => {
      var path = "/auth/logout"
      context.commit("removeAuthToken")

      return apiUtils.post(path, null)
    },
    signup: (context, { email, password }) => {
      var path = "/auth/signup"
      var data = {
        email: email,
        password: password
      }

      return apiUtils.post(path, data)
    },
    verifyEmail: (context, { userId, token }) => {
      var path = "/auth/verification/email"
      var data = {
        userId: userId,
        token: token
      }
      return apiUtils.post(path, data)
    },
    resentEmail: context => {
      var path = "/auth/verification/email/resend"
      return apiUtils.post(path, null)
    },
    updateToken: (context, { token }) => {
      context.commit("updateAuthToken", token)
    },
    forgetPassword: (context, { email }) => {
      var path = "/auth/forget-password"
      var data = {
        email: email
      }
      return apiUtils.post(path, data)
    },
    resetPassword: (context, { token, password, confirmedPassword }) => {
      var path = "/auth/reset-password"
      var data = {
        token: token,
        password: password,
        confirmedPassword: confirmedPassword
      }
      return apiUtils.post(path, data)
    }
  }
}
